import React from 'react';
import PropTypes from 'prop-types';

import { augmentClassName } from '../../../utils/GlobalCssProxy';
import { Provider as AppContextProvider } from '../../../stores/profile/profile-app-context';
import moduleStyles from './profile-app.module.scss';
import TemplateFactory from './template-factory';

const className = augmentClassName(moduleStyles);

//React.memo prevents unnecessary re-renders especially when context runs a function but doesn't actually change i.e. PageOffsetsTop
// eslint-disable-next-line prefer-arrow-callback
const ProfileApp = React.memo(function ProfileApp({
  channel,
  className: classNameProp,
  mpTicker,
  templateOverride,
  ticker,
  urlDomain = window.location.origin,
  urlPrefix = 'public',
  xid,
  yyy
}) {
  // Encode URL ticker parameter when it ends with hashtag e.g. BRC9#, ISVT#
  const tickerParam = window.location.href.match(/ticker=\w+#/g);
  let hasHashID = window.location.hash;
  const hasYYY = window.location.href.match(/&yyy=\w+/g);
  if (hasYYY) hasHashID = false;

  if (tickerParam !== null) {
    ticker = tickerParam[0].replace('ticker=', '');
    if (hasHashID) {
      ticker = ticker.replace('#', '');
    } else {
      window.history.replaceState(
        null,
        '',
        window.location.href.replace(ticker, encodeURIComponent(ticker))
      );
    }
  }

  channel = (channel || 'public').toLowerCase().replace(/\s|-/g, ' ').trim();

  const containerClass = className.string('page-container');
  const classes = classNameProp ? `${classNameProp} ${containerClass}` : containerClass;

  return (
    <div className={classes} data-channel={channel}>
      <AppContextProvider
        channel={channel}
        mpTicker={mpTicker}
        templateOverride={templateOverride}
        ticker={ticker ? decodeURIComponent(ticker) : undefined}
        urlDomain={urlDomain}
        urlPrefix={urlPrefix}
        xid={xid}
        yyy={yyy}
      >
        <TemplateFactory />
      </AppContextProvider>
    </div>
  );
});

ProfileApp.propTypes = {
  channel: PropTypes.string,
  className: PropTypes.string,
  mpTicker: PropTypes.string,
  templateOverride: PropTypes.string,
  ticker: PropTypes.string,
  urlDomain: PropTypes.string,
  urlPrefix: PropTypes.string,
  xid: PropTypes.string,
  yyy: PropTypes.string
};

export default ProfileApp;
